import { GetFunc } from "./types";

export const getSize = (percentDiff: number) => (value: number) =>
  value / percentDiff;

export const getDesktopOptions = (getWidth: GetFunc, getHeight: GetFunc) => ({
  map: {
    top: getWidth(-443),
    left: getHeight(-383),
  },
  cars: [
    {
      lightingColor: "#47B4E3",
      label: "Kenworth W900",
      color: "#47B4E3", // Blue
      wrapper: {
        from: {
          top: getHeight(774),
          left: getWidth(772),
        },
        to: [
          {
            top: getHeight(735),
            left: getWidth(829),
            config: {
              duration: 3000,
            },
          },
          {
            top: getHeight(697),
            left: getWidth(822),
            config: {
              duration: 1500,
            },
          },
          {
            top: getHeight(669),
            left: getWidth(730),
            config: {
              duration: 3000,
            },
          },
          {
            top: getHeight(729),
            left: getWidth(724),
            config: {
              duration: 2400,
            },
          },
          {
            top: getHeight(792),
            left: getWidth(744),
            config: {
              duration: 2400,
            },
          },
          {
            top: getHeight(774),
            left: getWidth(772),
            config: {
              duration: 900,
            },
          },
        ],
        loop: {
          reverse: true,
        },
      },
      icon: {
        from: {
          transform: "rotate(50deg)",
        },
        to: [
          {
            transform: "rotate(-8deg)",
          },
          {
            transform: "rotate(-62deg)",
            delay: 1300,
          },
          {
            transform: "rotate(-160deg)",
            delay: 2800,
          },
          {
            transform: "rotate(-196deg)",
            delay: 2000,
          },
          {
            transform: "rotate(-300deg)",
            delay: 2400,
          },
        ],
        loop: {
          from: {
            transform: "rotate(50deg)",
          },
          delay: 3700,
        },
        delay: 3100,
        config: {
          duration: 200,
        },
      },
    },
    {
      lightingColor: "#47B4E3",
      label: "Peterbilt 379",
      color: "#FF6B00", // Orange
      wrapper: {
        from: {
          top: getHeight(459),
          left: getWidth(523),
        },
        to: [
          {
            top: getHeight(424),
            left: getWidth(568),
            config: {
              duration: 1000,
            },
          },
          {
            top: getHeight(383),
            left: getWidth(618),
            config: {
              duration: 1000,
            },
          },
          {
            top: getHeight(627),
            left: getWidth(323),
            config: {
              duration: 0,
            },
          },
          {
            top: getHeight(552),
            left: getWidth(359),
            config: {
              duration: 1100,
            },
            delay: 6000,
          },
          {
            top: getHeight(508),
            left: getWidth(421),
            config: {
              duration: 1100,
            },
          },
          {
            top: getHeight(479),
            left: getWidth(503),
            config: {
              duration: 1100,
            },
          },
          {
            top: getHeight(459),
            left: getWidth(523),
            config: {
              duration: 500,
            },
          },
        ],
        loop: {
          reverse: true,
        },
      },
      icon: {
        from: {
          transform: "rotate(50deg)",
        },
        to: [
          {
            transform: "rotate(54deg)",
            delay: 1000,
            config: {
              duration: 300,
            },
          },
          {
            transform: "rotate(90deg)",
            delay: 3000,
            config: {
              duration: 900,
            },
          },
          {
            transform: "rotate(54deg)",
            config: {
              duration: 200,
            },
          },
        ],
        loop: {
          from: {
            transform: "rotate(50deg)",
          },
          delay: 6400,
        },
        delay: 6000,
      },
    },
    {
      lightingColor: "#85a893",
      label: "Freightliner Cascadia 113",
      color: "#85a893", // Green
      wrapper: {
        from: {
          top: getHeight(993),
          left: getWidth(241),
        },
        to: [
          {
            top: getHeight(909),
            left: getWidth(300),
            config: {
              duration: 2200,
            },
          },
          {
            top: getHeight(888),
            left: getWidth(302),
            config: {
              duration: 2500,
            },
          },
          {
            top: getHeight(748),
            left: getWidth(381),
            config: {
              duration: 2500,
            },
          },
          {
            top: getHeight(806),
            left: getWidth(506),
            config: {
              duration: 2500,
            },
          },
          {
            top: getHeight(887),
            left: getWidth(432),
            config: {
              duration: 2000,
            },
          },
          {
            top: getHeight(895),
            left: getWidth(393),
            config: {
              duration: 600,
            },
          },
          {
            top: getHeight(993),
            left: getWidth(241),
            config: {
              duration: 3000,
            },
          },
        ],
        loop: {
          reverse: true,
        },
      },
      icon: {
        from: {
          transform: "rotate(30deg)",
        },
        to: [
          {
            transform: "rotate(114deg)",
            delay: 1800,
          },
          {
            transform: "rotate(215deg)",
            delay: 2400,
          },
          {
            transform: "rotate(252deg)",
            delay: 1800,
          },
          {
            transform: "rotate(218deg)",
            delay: 500,
          },
        ],
        loop: {
          from: {
            transform: "rotate(30deg)",
          },
          delay: 8000,
        },
        delay: 5400,
        config: {
          duration: 200,
        },
      },
    },
    {
      lightingColor: "#47B4E3",
      label: "2021 Chevy Suburban",
      color: "#8D99FF",
      wrapper: {
        from: {
          top: getHeight(1080),
          left: getWidth(901),
        },
        to: [
          {
            top: getHeight(1200),
            left: getWidth(828),
            config: {
              duration: 4400,
            },
          },
          {
            top: getHeight(1200),
            left: getWidth(934),
            config: {
              duration: 4400,
            },
          },
          {
            top: getHeight(1080),
            left: getWidth(901),
            config: {
              duration: 4400,
            },
          },
        ],
        loop: {
          reverse: true,
        },
      },
      icon: {
        from: {
          transform: "rotate(210deg)",
        },
        to: [
          {
            transform: "rotate(90deg)",
            delay: 4300,
          },
          {
            transform: "rotate(-24deg)",
            delay: 4300,
          },
        ],
        loop: {
          from: {
            transform: "rotate(210deg)",
          },
          delay: 4300,
        },
        config: {
          duration: 200,
        },
      },
    },
  ],
});

export const getNotificationOptions = (width: number, isMobile: boolean) => {
  const leftTo = (width / 100) * (isMobile ? 15 : 25);
  return [
    {
      label: "Entering Manhattan geofence",
      options: {
        card: {
          from: {
            opacity: 1,
            top: 10,
            left: leftTo,
          },
          to: [
            {
              opacity: 0,
              top: 10,
              left: width,
              config: {
                duration: 200,
              },
              delay: 1000,
            },
            {
              opacity: 1,
              top: 10,
              left: leftTo,
              config: {
                duration: 200,
              },
              delay: 11000,
            },
          ],
          loop: {
            from: {
              opacity: 1,
              top: 10,
              left: leftTo,
            },
            delay: 800,
          },
        },
        button: {
          from: {
            x: 0,
          },
          to: [
            {
              x: 30,
              config: {
                duration: 0,
              },
              delay: 1200,
            },
            {
              x: 0,
              config: {
                duration: 200,
              },
              delay: 11100,
            },
          ],
          loop: {
            from: {
              x: 0,
            },
            delay: 700,
          },
        },
        time: {
          from: {
            x: 0,
          },
          to: [
            {
              x: 30,
              config: {
                duration: 0,
              },
              delay: 1200,
            },
            {
              x: 0,
              config: {
                duration: 100,
              },
              delay: 11100,
            },
          ],
          loop: {
            from: {
              x: 0,
            },
            delay: 800,
          },
        },
        label: {
          from: {
            x: 0,
          },
          to: [
            {
              x: 30,
              config: {
                duration: 0,
              },
              delay: 1200,
            },
            {
              x: 0,
              config: {
                duration: 200,
              },
              delay: 11100,
            },
          ],
          loop: {
            from: {
              x: 0,
            },
            delay: 700,
          },
        },
      },
    },
    {
      label: "Leaving Manhattan geofence",
      options: {
        card: {
          from: {
            opacity: 0,
            top: 10,
            left: width,
          },
          to: [
            {
              opacity: 1,
              top: 10,
              left: leftTo,
              config: {
                duration: 200,
              },
              delay: 1300,
            },
            {
              opacity: 0,
              top: 10,
              left: width,
              config: {
                duration: 200,
              },
              delay: 1000,
            },
          ],
          loop: {
            from: {
              opacity: 0,
              top: 10,
              left: leftTo,
            },
            delay: 10500,
          },
        },
        button: {
          from: {
            x: 30,
          },
          to: [
            {
              x: 0,
              config: {
                duration: 200,
              },
              delay: 1400,
            },
            {
              x: 30,
              config: {
                duration: 0,
              },
              delay: 1100,
            },
          ],
          loop: {
            from: {
              x: 30,
            },
            delay: 10500,
          },
        },
        time: {
          from: {
            x: 30,
          },
          to: [
            {
              x: 0,
              config: {
                duration: 100,
              },
              delay: 1400,
            },
            {
              x: 30,
              config: {
                duration: 0,
              },
              delay: 1200,
            },
          ],
          loop: {
            from: {
              x: 30,
            },
            delay: 10500,
          },
        },
        label: {
          from: {
            x: 30,
          },
          to: [
            {
              x: 0,
              config: {
                duration: 200,
              },
              delay: 1400,
            },
            {
              x: 30,
              config: {
                duration: 0,
              },
              delay: 1100,
            },
          ],
          loop: {
            from: {
              x: 30,
            },
            delay: 10500,
          },
        },
      },
    },
  ];
};
